module.exports = __webpack_public_path__ + "img/phonecall_gold.452b43a.png";